import { IDevice } from './device.model';
import { IProduct, IProductRange } from './product.model';
import { SavedState } from './SavedState.model';
import { EnclosureTypes } from '../../enclosure/models/enclosure-type.model';
import { ConfiguratorModel } from './prisma-xs.model';
import { IApartment } from '../../enclosure/models/apartment.model';

export interface IConfigurationEnclosure {
  enclosureId: number;
  configuration: Partial<ConfiguratorModel>;
}

export interface IEnclosure extends IEnclosureInfo {
  projectId: number;
  enclosureSpecId: number;
  productRangeId: number;
  description: string;
  productId: number;
  devices: IDevice[];
  enclosureSpecs?: IEnclosureSpecs[];
  productRange?: IProductRange;
  apartments?: IApartment[];
  reference: string;
  product: IProduct;
  /* @DEPRECATED */
  savedState: SavedState;
  /* @DEPRECATED */
  isCurrent: number;
  /* @DEPRECATED */
  isSaved: boolean;
  /* @DEPRECATED */
  optionstring: string;
  /* @DEPRECATED */
  isCopied: boolean;
  /* @DEPRECATED */
  overrideRange: number;
  enclosureType?: EnclosureTypes;
  createdByCurrentUser?: boolean;
  enclosureDescription?: IEnclosureDescription;
  mountingType?: number | string;
  doorType?: number;
  rows?: number;
  fields?: number;
  enclosureOptions: IEnclosureOptions[];
  ipType?: string;
  socleHeight?: number;
  minRows?: number;
  minFields?: number;
  enclosureDateCreated?: string;
  enclosureDateUpdated?: string;
  selectedCurrent?: string;
  installationDate?: Date;
  enclosureProperties?: IEnclosureProperties[];
  is210mmDepthAllowed?: boolean;
  isSldConfigured: boolean;
  occupiedCapacity?: number;
  isDownloadInProgress?: boolean;
  isDownloadProtocolPdfInProgress?: boolean;
  isDownloadProtocolWordInProgress?: boolean;
  multimediaProductPreconfigured?: IProduct;
}

export interface IEnclosureInfo {
  enclosureId: number;
  name: string;
}

export interface IEnclosureProjectOverview {
  enclosureId: number;
  projectId: number;
  productRangeId: number;
  productRange?: IProductRange;
  name: string;
  apartments?: IApartment[];
  enclosureSpecs?: IEnclosureSpecs[];
  enclosureType?: EnclosureTypes;
  enclosureDescription?: IEnclosureDescription;
  createdByCurrentUser?: boolean;
  product: IProduct;
  enclosureDateCreated?: string;
  enclosureDateUpdated?: string;
  isSldConfigured: boolean;
}

export interface IEnclosureSupportSpecs {
  enclosureSupportSpecId: number;
  reference: string;
  supportName: string;
  length: number;
  enclosurePoints: IEnclosurePoint[];
  height: number;
  width: number;
}

export interface IEnclosurePoint {
  positionX: number;
  positionY: number;
}

export interface IEnclosureDescription {
  name?: string;
  fields?: number;
  rows?: number;
  mountingType?: string;
  doorType?: string;
  ipType?: string;
}

export interface IEnclosureProperties {
  value: string;
  property: string;
}

export interface IEnclosureSpecs {
  enclosureSpecId: number;
  enclosureSupportSpec: IEnclosureSupportSpecs;
  numberOfModulesPerRow: number;
  numberOfRows: number;
  image: string;
  ratedCurrent: string;
  allowedRatedCurrents?: string[];
  productId: number;
  isAP: number;
  isUP: number;
  isDefault: number;
  field: number;
  hasCover?: boolean;
  canSelectDevicesBetweenRows?: boolean;
  enclosureOptions: IEnclosureOptions[];
  multi: number;
  hasPowerTagGrid: boolean;
  specialEnclosureDimensions?: ISpecialEnclosureDimension[];
}

export interface IEnclosureSpecsWithDimensions extends IEnclosureSpecs {
  height: number;
  width: number;
  depth: number;
}

export interface ISpecialEnclosureDimension {
  qNoOptions: string[];
  dimensions: IEnclosureSpecsWithDimensions;
}

export interface IPredefinedEnclosureSettings {
  predefinedEnclosureSettingsId: number;
  productRangeId: number;
  productRange: IProductRange;
  productId: number;
  enclosureSpecs: IEnclosureSpecs;
  isSelected: boolean;
  displayWizard: number;
}

export interface IEnclosureOptions {
  optionId: number;
  parentOptionId: number;
  name: string;
  isSelectable: number;
  isDefault: number;
  qNo: string;
  enclosureOptions: IEnclosureOptions[];
  headerId: number;
  viewEnumerate: number;
}

export interface IEnclosureSpecToOptions {
  enclosureSpecId: number;
  id: number;
  optionId: number;
}

export interface EnclosureFlags  {
  flag: EnclosureFlagsConstants;
  value: number;
}

export enum EnclosureFlagsConstants {
  ADDED_TO_AN_EXISTING_BOM_ITEM = 'ADDED_TO_AN_EXISTING_BOM_ITEM'
}

export enum EnclosureProperties {
  RATED_CURRENT = 'RATED_CURRENT',
  SLD_TREE_DESCRIPTION = 'SLD_TREE_DESCRIPTION'
}

export interface IEnclosureDocumentDetails {
  title: string;
  enclosure: IEnclosure;
}

export interface IEnclosureOccupancy
{
  id :number;
  occupancy: number;
}
